<template>
    <div class="dropdown-container" @click="onTypeClick">
      <div class="dropdown-text"> {{ verifyText(verifyType) }} </div>
      <img class="dropdown-icon" src="@/icons/dropdown.png">
    </div>
  </template>
<script>
import { VerifyType } from '@/config/entrance.js'

export default {
  name: 'DropDownView',
  props: {
    verifyType: {
      type: Number,
      default: VerifyType.SMS
    }
  },
  data() {
    return {}
  },
  watch: {},
  methods: {
    onTypeClick() {
      this.$emit('onTypeClick')
    },
    verifyText(type) {
      switch (type) {
        case VerifyType.SMS:
          return this.$t('手机号码')
        case VerifyType.EMAIL:
          return this.$t('邮箱地址')
        default:
          return ''
      }
    }
  }
}
</script>
  <style lang="scss" scoped>

  .dropdown-container {
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0px 16px;
    background-color: #F5F7FA;
    margin-top: 16px;
    border-radius: 8px;
    .dropdown-text {
        font-size: 14px;
        color:#2c2c2c;
    }
    .dropdown-icon{
        width: 20px;
        height: 20px;
    }
  }
  </style>
